import React, {useState, useRef} from 'react'
import Sidebar from "../../components/sidebar/Sidebar";
import "../../styles/sidebar/sidebar.css";
import Header from "../../components/header/Header";
import RecordedDataComponent from '../../components/recordedData/RecordedDataComponent';

const CoordinatorApprovedData = () => {
    return (
        <>
        <div className="recorded-data-container">
                <Sidebar role="coordinator"/>
            <div className="main-content">
                <Header/>
                <RecordedDataComponent role="coordinator" title="APPROVING SCANNED RECORDS"/>
            </div>
        </div>
        </>
      )
}

export default CoordinatorApprovedData